// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__3e_T8","main-image":"Header_main-image__2fYY_"};